"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DummySigner = void 0;
class DummySigner {
    constructor(publicKey) {
        this.publicKey = publicKey;
    }
    sign(_hash, _lowR) {
        return Buffer.alloc(64, 0);
    }
    signSchnorr(hash) {
        return Buffer.alloc(64, 0);
    }
}
exports.DummySigner = DummySigner;
